export const shell: Record<string, string> = {
  // Navigation labels
  'Schedule': 'Planification',
  'Duty Board': 'Tableau de service',
  'Shifts': 'Vacations',
  'Leave': 'Congés',
  'Activity': 'Activité',
  'Ops Centre': 'Centre des opérations',
  'Home': 'Accueil',
  'Live View': 'Vue en direct',
  'Shift History': 'Historique des vacations',
  'Alarms': 'Alarmes',
  'History': 'Historique',
  'Guards': 'Agents',
  'All Staff': 'Tout le personnel',
  'Licence Verification': 'Vérification des licences',
  'Reports': 'Rapports',
  'Incident Reports': "Rapports d'incident",
  'Summary Reports': 'Rapports de synthèse',
  'Analytics': 'Analyses',
  'Sites': 'Sites',
  'Admin': 'Administration',
  'Clients': 'Clients',
  'Account Management': 'Gestion des comptes',
  'Payroll': 'Paie',

  // Navigation summaries
  'Duty coverage, roster design and leave planning':
    'Couverture des services, conception des plannings et gestion des congés',
  'Quick duty + guard assignment': 'Affectation rapide des services et des agents',
  'Merged guard-facing roster view': 'Vue consolidée du planning côté agents',
  'Approve and manage guard leave': 'Approuver et gérer les congés des agents',
  'Live map and field visibility': 'Carte en direct et visibilité terrain',
  'Immediate priorities and live field visibility': 'Priorités immédiates et visibilité terrain en direct',
  'Immediate operational priorities': 'Priorités opérationnelles immédiates',
  'Live guard positions': 'Positions des agents en direct',
  'Past shift records': 'Historique des vacations effectuées',
  'Panic alerts and response queue': 'Alertes de détresse et file de réponse',
  'Open and acknowledged alarms': 'Alarmes ouvertes et prises en compte',
  'Past alarm records': 'Historique des alarmes',
  'Team directory and licence checks': "Annuaire de l'équipe et contrôle des licences",
  'People and contact details': 'Personnel et coordonnées',
  'Compliance monitoring': 'Suivi de la conformité',
  'Incident reviews and shift summaries': 'Examen des incidents et synthèses de vacation',
  'Incident triage and reviews': 'Tri et examen des incidents',
  'Daily reports, patrol reports and visitor logs':
    'Rapports journaliers, rapports de ronde et registres des visiteurs',
  'Performance and workload trends': 'Tendances de performance et de charge de travail',
  'Sites, patrols and posts': 'Sites, rondes et postes',
  'Clients, admin access and payroll': 'Clients, accès administrateur et paie',
  'Client onboarding and portal access': 'Intégration des clients et accès au portail',
  'Company administrator accounts': "Comptes administrateurs de l'entreprise",
  'Payroll setup and review': 'Configuration et vérification de la paie',

  // Shell chrome
  'Admin Portal': "Portail d'administration",
  'Security operations workspace': 'Espace de gestion des opérations de sécurité',
  'Guardian logo': 'Logo Guardian',
  'Expand sidebar': 'Développer le panneau latéral',
  'Collapse sidebar': 'Réduire le panneau latéral',
  'Workspace': 'Espace de travail',
  'Settings / Profile': 'Paramètres / Profil',
  'Workspace preferences and account details':
    "Préférences de l'espace de travail et détails du compte",
  'Logout': 'Déconnexion',
  'End the current admin session': 'Terminer la session administrateur en cours',

  // Alarm banner
  'A guard': 'Un agent',
  'Alarm Triggered': 'Alarme déclenchée',
  'Acknowledge alarm': "Prendre en compte l'alarme",
  'Acknowledge': 'Prendre en compte',
  'View all alarms': 'Voir toutes les alarmes',
  'View': 'Voir',
  'Dismiss notification': 'Ignorer la notification',

  // Notifications dropdown
  'just now': "à l'instant",
  '{count}m ago': 'il y a {count} min',
  '{count}h ago': 'il y a {count} h',
  '{count}d ago': 'il y a {count} j',
  'Notifications': 'Notifications',
  '{count} unread': '{count} non lu(es)',
  'Mark all read': 'Tout marquer comme lu',
  'No notifications yet': 'Aucune notification pour le moment',
  'Go To': 'Ouvrir',

  // Session timeout dialog
  'Session security': 'Sécurité de la session',
  'Your session is ending': 'Votre session se termine',
  'Are you still working?': 'Êtes-vous toujours là ?',
  'For security, you must sign in again after the maximum session duration.':
    'Pour des raisons de sécurité, vous devez vous reconnecter après la durée maximale de session.',
  'You will be signed out automatically because there has been no activity.':
    "Vous allez être déconnecté automatiquement en raison d'une période d'inactivité.",
  'Signing out...': 'Déconnexion...',
  'Sign in again': 'Se reconnecter',
  'Stay signed in': 'Rester connecté',

  // Site tour
  'Site tour': 'Visite guidée',
  'Skip tour': 'Passer la visite',
  'Get started': 'Commencer',
  'Welcome': 'Bienvenue',
  'Welcome to OdinsEye': 'Bienvenue sur OdinsEye',
  'This is your security operations workspace. This short tour points out the main areas of the portal — it takes about a minute, and you can replay it anytime from Settings / Profile.':
    "Voici votre espace de gestion des opérations de sécurité. Cette courte visite présente les principales sections du portail — elle dure environ une minute et vous pouvez la revoir à tout moment depuis Paramètres / Profil.",
  'Rostering': 'Plannings',
  'Schedule & rostering': 'Planification et plannings',
  'Build and manage your roster. Use the Duty Board to create duties and assign guards, see the guard-facing roster under Shifts, and approve time off under Leave.':
    'Créez et gérez votre planning. Utilisez le Tableau de service pour créer des services et affecter des agents, consultez le planning côté agents dans Vacations et approuvez les absences dans Congés.',
  'Live ops': 'Opérations en direct',
  'At a glance': 'En un coup d’œil',
  'Your ops centre': 'Votre centre des opérations',
  'Home is your operational starting point. It brings urgent alarms, missed shift starts, leave requests, recent reports, coverage gaps and expiring licences into one action-focused view.':
    'L’onglet Accueil est votre point de départ opérationnel. Il réunit les alarmes urgentes, les prises de poste manquées, les demandes de congé, les rapports récents, les lacunes de couverture et les licences arrivant à expiration dans une vue axée sur l’action.',
  'Act now': 'Agir maintenant',
  'Immediate priorities': 'Priorités immédiates',
  'Alarms, no-shows and leave requests are ordered into one queue. Select any row to open the right response workspace with its site, date or record ready.':
    'Les alarmes, les absences à la prise de poste et les demandes de congé sont regroupées dans une seule file. Sélectionnez une ligne pour ouvrir l’espace d’intervention approprié avec le site, la date ou le dossier déjà préparé.',
  'Plan ahead': 'Anticiper',
  'Coverage horizon': 'Horizon de couverture',
  'See uncovered and unpublished duties across the next 14 days. Selecting a gap opens that site and date directly on the Duty Board.':
    'Consultez les services non couverts et non publiés des 14 prochains jours. La sélection d’une lacune ouvre directement le site et la date concernés dans le Tableau de service.',
  'Ops Centre, live view & history': 'Centre des opérations, vue en direct et historique',
  'Return to Home for operational priorities, follow guard positions on the live map, or replay completed shifts — routes, checkpoint scans and events — under Shift History.':
    'Revenez à l’Accueil pour les priorités opérationnelles, suivez la position des agents sur la carte en direct ou revisualisez les vacations terminées — itinéraires, scans de points de contrôle et événements — dans l’Historique des vacations.',
  'Back to Ops Centre': 'Retour au centre des opérations',
  'Live activity': 'Activité en direct',
  'Follow guard positions on the live map while shifts are running, and replay completed shifts — routes, checkpoint scans and events — under Shift History.':
    "Suivez la position des agents sur la carte en direct pendant les vacations, et revisualisez les vacations terminées — itinéraires, scans de points de contrôle et événements — dans l'Historique des vacations.",
  'Response': 'Réponse',
  'Panic alerts raised from the field arrive here. Acknowledge and resolve them from the response queue — a badge on this item shows open alarms at a glance.':
    "Les alertes de détresse déclenchées sur le terrain arrivent ici. Prenez-les en compte et résolvez-les depuis la file de réponse — un badge sur cet élément indique d'un coup d'œil les alarmes ouvertes.",
  'Compliance': 'Conformité',
  'Staff & licence verification': 'Personnel et vérification des licences',
  'Your team directory: admins, managers and guards. Add a user to email them an invite, or share a join code, and open any profile for full details. The Licence Verification tab is where you review submitted security licences and approve or reject them.':
    "L'annuaire de votre équipe : administrateurs, responsables et agents. Ajoutez un utilisateur pour lui envoyer une invitation par e-mail, ou partagez un code d'adhésion, et ouvrez un profil pour voir tous les détails. L'onglet Vérification des licences vous permet d'examiner les licences de sécurité soumises et de les approuver ou de les rejeter.",
  'Reporting': 'Rapports',
  'Incident reports from the field land here for triage and review, while Summary Reports gathers daily reports, patrol reports and visitor logs — all exportable.':
    "Les rapports d'incident du terrain arrivent ici pour tri et examen, tandis que Rapports de synthèse regroupe les rapports journaliers, les rapports de ronde et les registres des visiteurs — tous exportables.",
  'Insights': 'Statistiques',
  'Track performance and workload trends across sites, shifts and guards.':
    'Suivez les tendances de performance et de charge de travail par site, vacation et agent.',
  'Patrols': 'Rondes',
  'Sites, posts & patrols': 'Sites, postes et rondes',
  'Set up client sites with geofences, define posts, and build patrol routes with checkpoints for guards to scan on their rounds. Patrol creation starts here.':
    'Configurez les sites clients avec des zones géorepérées, définissez des postes et créez des itinéraires de ronde avec des points de contrôle que les agents scannent pendant leurs rondes. La création de rondes commence ici.',
  'Administration': 'Administration',
  'Onboard clients and give them portal access, manage company administrator accounts, and set up payroll.':
    "Intégrez des clients et donnez-leur accès au portail, gérez les comptes administrateurs de l'entreprise et configurez la paie.",
  'Updates': 'Mises à jour',
  'Licence submissions, report updates and alarms land here, so nothing slips past you.':
    'Les soumissions de licences, les mises à jour de rapports et les alarmes arrivent ici — rien ne vous échappe.',
  'Preferences': 'Préférences',
  'Settings & profile': 'Paramètres et profil',
  'Your account details and workspace preferences live here — including the option to replay this tour whenever you like.':
    'Vos informations de compte et les préférences de votre espace de travail se trouvent ici — y compris la possibilité de revoir cette visite quand vous le souhaitez.',
  'All set': 'Tout est prêt',
  'You’re ready to go': 'Vous êtes prêt',
  'A good first step: create a site, add your staff, then build your first roster on the Duty Board. Replay this tour anytime from Settings / Profile.':
    'Un bon point de départ : créez un site, ajoutez votre personnel, puis construisez votre premier planning sur le Tableau de service. Revoyez cette visite à tout moment depuis Paramètres / Profil.',

  // Access gate (App.tsx)
  'Portal access is limited': "L'accès au portail est limité",
  'This web workspace is for staff with a management role and invited client users. Guard accounts should continue using the field app.':
    "Cet espace web est réservé au personnel ayant un rôle de gestion et aux utilisateurs clients invités. Les agents doivent continuer à utiliser l'application terrain.",

  // An area the user's roles do not open (DashboardShell)
  'This area is not part of your role': 'Cette section ne fait pas partie de votre rôle',
  'Your roles do not include this part of the workspace. Ask a system administrator if you need it.':
    'Vos rôles n’incluent pas cette partie de l’espace de travail. Adressez-vous à un administrateur système si vous en avez besoin.',
  // Sidebar summary for Admin › Roles & Permissions, reached through navItems.
  'What each role can open, and who owns the workspace':
    'Ce que chaque rôle peut ouvrir, et à qui appartient l’espace de travail',
};
